<template>
	<section class="base-modal wh100 fixed left0 top0 z999999 flex-center"
           v-if="isModal"
           @click="close">
    <slot></slot>
	</section>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'base-modal',
		data () {
			return {
			}
		},
		computed: {
			...mapState({
        isModal: 'isModal'
      })
		},
		methods: {
      close () {
        this.$store.commit('SET_STATE_KEY', {name: 'isModal', val: false})
      }
		}
	}
</script>

<style lang="less">
	.base-modal {
    background-color: rgba(0, 0, 0, 0.8);
	}
</style>